var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_2229)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    transform: "rotate(-90 15 15)",
    fill: "#191919",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6125 11.637C21.4969 11.5212 21.3595 11.4292 21.2083 11.3665C21.0571 11.3038 20.895 11.2715 20.7313 11.2715C20.5676 11.2715 20.4055 11.3038 20.2543 11.3665C20.103 11.4292 19.9657 11.5212 19.85 11.637L15 16.487L10.15 11.637C9.91631 11.4033 9.59932 11.272 9.26878 11.272C8.93825 11.272 8.62125 11.4033 8.38753 11.637C8.15381 11.8708 8.02251 12.1878 8.02251 12.5183C8.02251 12.8488 8.15381 13.1658 8.38753 13.3995L14.125 19.137C14.2407 19.2529 14.378 19.3449 14.5293 19.4076C14.6805 19.4703 14.8426 19.5026 15.0063 19.5026C15.17 19.5026 15.3321 19.4703 15.4833 19.4076C15.6345 19.3449 15.7719 19.2529 15.8875 19.137L21.625 13.3995C22.1 12.9245 22.1 12.1245 21.6125 11.637Z",
    fill: "#ECECEC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_2229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "matrix(0 1 -1 0 30 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/Arrow-Down.46ae69af91c1f8f9895327014f1eed04.svg";
export { ForwardRef as ReactComponent };